var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_681_5904",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_681_5904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.74923C10.0769 4.74923 8.23258 5.51317 6.87275 6.87299C5.51292 8.23282 4.74899 10.0771 4.74899 12.0002C4.74899 13.9233 5.51292 15.7676 6.87275 17.1275C8.23258 18.4873 10.0769 19.2512 12 19.2512C13.9231 19.2512 15.7674 18.4873 17.1272 17.1275C18.487 15.7676 19.251 13.9233 19.251 12.0002C19.251 10.0771 18.487 8.23282 17.1272 6.87299C15.7674 5.51317 13.9231 4.74923 12 4.74923ZM12 1.65723C14.7422 1.66014 17.3713 2.75078 19.3104 4.68983C21.2494 6.62889 22.3401 9.25799 22.343 12.0002C22.3401 14.7425 21.2494 17.3716 19.3104 19.3106C17.3713 21.2497 14.7422 22.3403 12 22.3432C9.25774 22.3403 6.62865 21.2497 4.68959 19.3106C2.75053 17.3716 1.65989 14.7425 1.65698 12.0002C1.65989 9.25799 2.75053 6.62889 4.68959 4.68983C6.62865 2.75078 9.25774 1.66014 12 1.65723Z",
    fill: "#D80001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmiIcon);
export default __webpack_public_path__ + "static/media/omi-icon.55fd6393e4ff2360b5931180a0518c6d.svg";
export { ForwardRef as ReactComponent };